/**
 * owa-service/lib/contract/BusyType expresed as an enum. This allows for index lookups
 */
enum FreeBusyType {
    'Free',
    'Tentative',
    'Busy',
    'OOF',
    'WorkingElsewhere',
    'NoData',
    'Loading',
}

export default FreeBusyType;
